import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import { ProductManagementModel } from '../models/management/products';
import { UpdateProductModel } from '@app/modules/products/models';

@Injectable({ providedIn: 'root' })
export class ProductsManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(params: PaginationSearchModel): Observable<PaginatedResultModel<ProductManagementModel>> {
    return this.apiService.get<PaginatedResultModel<ProductManagementModel>>(
      `${environment.url.prefixCustoms}v2/management/products`,
      {
        params,
      },
      { isShowLoader: false },
    );
  }

  public getProduct(id: number): Observable<ProductManagementModel> {
    return this.apiService.get<ProductManagementModel>(
      `${environment.url.prefixCustoms}v2/management/products/${id}`,
      {},
      { isShowLoader: true },
    );
  }

  public update(id: number, payload: UpdateProductModel): Observable<void> {
    return this.apiService.put<void>(`${environment.url.prefixCustoms}v2/management/products/${id}`, payload);
  }
}
